import { useContext } from 'react'
import { I18nContext, I18nContextValue } from './I18nProvider'

// Access the current language and the t() translation function. Must be called
// from within an <I18nProvider> tree (wired in each app's main.tsx).
export function useTranslation(): I18nContextValue {
  const context = useContext(I18nContext)
  if (context === null) {
    throw new Error('useTranslation must be used within an I18nProvider. Wrap the app tree with <I18nProvider> in main.tsx.')
  }
  return context
}
